import { initializeApp } from "firebase/app";
import { getAnalytics, setAnalyticsCollectionEnabled, setDefaultEventParameters } from "firebase/analytics";

/**
 * Firebase Config - GA4 Analytics uniquement
 * Auth et Database sont gérés par Supabase
 */
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase (uniquement pour Analytics/GA4)
const app = initializeApp(firebaseConfig);

// ===== CONFIGURATION FIREBASE ANALYTICS (GA4) RGPD-FRIENDLY =====
export const analytics = getAnalytics(app);

// Configuration respectueuse de la vie privée (selon Analytics.md)
setAnalyticsCollectionEnabled(analytics, true);

// Paramètres par défaut pour la conformité RGPD sans bannière de cookies
setDefaultEventParameters({
  // Respect de la vie privée
  mode_prive: true,
  stockage_pub: 'refuse',
  stockage_analytics: 'refuse',
  
  // Anonymisation IP automatique
  anonymize_ip: true,
  
  // Désactivation des signaux Google pour la personnalisation
  allow_google_signals: false,
  allow_ad_personalization_signals: false,
  
  // Informations sur l'application
  app_version: process.env.REACT_APP_VERSION || '1.0.0',
  app_name: 'What 2 Do !',
  
  // Environnement de déploiement
  environment: process.env.NODE_ENV || 'development'
});

console.log('🔒 Firebase Analytics configuré avec respect RGPD');